import { cn } from "@/libs/cn";
import { GridTableCell, Tag, Tooltip } from "@/modules/common/components";
import { ANEEL_TARIFF_IMPORT_STATUS_OPTIONS, AneelTariffImportHistoryStatus } from "@/modules/common/types/AneelTariffs.enum";
import { AdminAneelTariffImportHistoryResponse } from "@/service/response/admin-aneel-tariffs";
import { formatDate, formatNameInitials } from "@/modules/common/utils/format";

import { gridLayout } from "./ImportHistoryListHeader";
import ImportErrorsModal from "./ImportErrorsModal";

interface ImportHistoryListLineProps {
  importHistory: AdminAneelTariffImportHistoryResponse;
}

const STATUS_TAG_VARIANT: Record<AneelTariffImportHistoryStatus, "success" | "warning" | "danger"> = {
  [AneelTariffImportHistoryStatus.SUCCESS]: "success",
  [AneelTariffImportHistoryStatus.PARTIAL]: "warning",
  [AneelTariffImportHistoryStatus.FAILED]: "danger",
};

const ImportHistoryListLine = ({ importHistory }: ImportHistoryListLineProps) => {
  const statusLabel = ANEEL_TARIFF_IMPORT_STATUS_OPTIONS.find((option) => option.value === String(importHistory.status))?.label ?? "-";
  const isFailed = importHistory.status === AneelTariffImportHistoryStatus.FAILED;

  return (
    <div
      className={cn(gridLayout, "bg-white border border-[#D6DEE9] md:rounded-none md:border-0 md:border-t md:bg-transparent rounded-lg")}
    >
      <GridTableCell label="Data/Hora" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {formatDate(importHistory.createdAt, "DD/MM/YYYY [às] HH:mm")}
      </GridTableCell>

      <GridTableCell label="Arquivo" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={importHistory.fileName} disabled={!importHistory.fileName}>
          <span className="block truncate">{importHistory.fileName ?? "-"}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Responsável" className="text-sm text-ui-navy-dark md:min-w-0">
        {importHistory.importedByAdminUserName === null ? (
          "-"
        ) : (
          <div className="flex items-center gap-2 md:min-w-0">
            <div className="flex items-center justify-center rounded-full bg-blue-800/10 text-blue-800 text-sm font-semibold h-8 w-8 shrink-0">
              {formatNameInitials(importHistory.importedByAdminUserName)}
            </div>
            <Tooltip label={importHistory.importedByAdminUserName} disabled={!importHistory.importedByAdminUserName}>
              <p className="wrap-break-word md:min-w-0 md:block md:truncate text-sm">{importHistory.importedByAdminUserName}</p>
            </Tooltip>
          </div>
        )}
      </GridTableCell>

      <GridTableCell label="Status" className="md:min-w-0">
        <div className="flex flex-col items-start gap-1">
          <Tag label={statusLabel} variant={STATUS_TAG_VARIANT[importHistory.status]} />
          <ImportErrorsModal errors={importHistory.errors} />
        </div>
      </GridTableCell>

      <GridTableCell label="Registros processados" className="text-sm text-ui-navy-dark whitespace-nowrap">
        {isFailed ? "-" : importHistory.countCreated}
      </GridTableCell>
    </div>
  );
};

export default ImportHistoryListLine;
